import React, { FC } from 'react';
import { Card, styled } from '@mui/material';
import HubspotForm from 'react-hubspot-form'

const GeneralForm: FC<Props> = (props) => {
  const { title, description, portalId, formId, className } = props;
  
  return (
    <StyledCard elevation={0} className={className}>
      <h3>{title}</h3>
      <p className="description" style={{marginBottom: '35px', lineHeight: '1.8em'}}>{description}</p>
      
      <HubspotForm
        region='na1'
        portalId={portalId}
        formId={formId}
        loading={<div>Form Loading...</div>}
      />
    </StyledCard>
  )
}

const StyledCard = styled(Card)(({ theme }) => ({
  padding: '1rem 2rem',
  marginTop: '2rem',
  borderRadius: '1rem'
}))

interface Props {
  title: string
  description?: string
  portalId: string
  formId: string
  /** Extra styling from the page, such as a border where the card sits on white. */
  className?: string
}

export default GeneralForm
